import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature } from '@openfeature/react-sdk';

export const isCopyPlainTextStripEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-copy-plain-text-strip',
    false
  );
